import { Eyebrow, Reveal } from "@/components/ui-bits";

const AdditionalCapacity = () => {
  return (
    <section data-testid="additional-capacity-section" aria-labelledby="additional-capacity-heading" className="bg-[#191c1e] py-16 text-white sm:py-20 lg:py-24">
      <div className="container-30 max-w-3xl">
        <Reveal>
          <Eyebrow light>Additional Capacity</Eyebrow>
          <h2
            id="additional-capacity-heading"
            data-testid="additional-capacity-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl"
          >
            WHEN ADDITIONAL CAPACITY IS REQUIRED.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg">
            When a shipment requires equipment or transportation capacity beyond what is available directly, 30 NORTH
            can arrange transportation through trusted partner carriers and manage the shipment from coordination
            through delivery.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default AdditionalCapacity;
